function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg035Serbia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#0052B4"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#D80027"
    },
    width: 512,
    height: 170.663
  }), /*#__PURE__*/React.createElement("rect", {
    y: 341.337,
    style: {
      fill: "#F0F0F0"
    },
    width: 512,
    height: 170.663
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M101.787,155.826v122.386c0,69.616,90.947,90.948,90.947,90.948s90.947-21.331,90.947-90.948V155.826  H101.787z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "139.401,177.16 246.067,177.16 246.067,134.493 224.733,145.16 192.733,113.16    160.733,145.16 139.401,134.493  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "262.348,295.251 193.014,225.918 123.681,295.251 146.308,317.879 193.014,271.172    239.721,317.879  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M262.348,230.493h-32.35c1.819-3.14,2.877-6.775,2.877-10.664c0-11.784-9.552-21.334-21.334-21.334  c-8.141,0-15.211,4.56-18.807,11.264c-3.597-6.703-10.666-11.264-18.807-11.264c-11.782,0-21.334,9.55-21.334,21.334  c0,3.889,1.059,7.525,2.877,10.664h-31.79c0,11.783,10.262,21.334,22.044,21.334h-0.71c0,11.783,9.551,21.334,21.334,21.334  c0,10.433,7.492,19.1,17.387,20.954l-16.809,37.953c8.055,3.275,16.858,5.093,26.09,5.093c9.232,0,18.035-1.819,26.09-5.093  l-16.809-37.953c9.894-1.854,17.387-10.522,17.387-20.954c11.783,0,21.334-9.551,21.334-21.334h-0.71  C252.085,251.826,262.348,242.275,262.348,230.493z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg035Serbia);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };